// extracted by mini-css-extract-plugin
export default {"loadingState":"NewLoadingState_loadingState__iYmo8","header":"NewLoadingState_header__CmA4f","avatar":"NewLoadingState_avatar__lAak3","info":"NewLoadingState_info__ZLJH3"};